export default "__VITE_ASSET__c1zHG9aM__"